import { User, TokenData } from "../../types";

export const SET_TOKENS = "SET_TOKENS";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESSFUL = "LOGIN_SUCCESSFUL";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESSFUL = "LOGOUT_SUCCESSFUL";
export const LOGOUT_FAILED = "LOGOUT_FAILED";

export const SESSION_MAX_AGE = "SESSION_MAX_AGE";
export const SET_SESSION_EXPIRY = "SET_SESSION_EXPIRY";
export const AUTH_FAILURE = "AUTH_FAILURE";
export const RESET_LOCKOUT = "RESET_LOCKOUT";

export const INITIATE_PASSWORD_CHANGE = "INITIATE_PASSWORD_CHANGE";

export const START_SPINNER = "START_SPINNER";
export const STOP_SPINNER = "STOP_SPINNER";

export const SET_USERNAME = "SET_USERNAME";
export const SET_AUTHENTICATED_WITH_KEYCLOAK =
  "SET_AUTHENTICATED_WITH_KEYCLOAK";

export const SET_FAILURE_MESSAGE = "SET_FAILURE_MESSAGE";

interface SetFailureMessageAction {
  type: typeof SET_FAILURE_MESSAGE;
  message: string | null;
}

interface StartSpinnerAction {
  type: typeof START_SPINNER;
}

interface StopSpinnerAction {
  type: typeof STOP_SPINNER;
}

interface SetTokensAction {
  type: typeof SET_TOKENS;
  tokenData: TokenData;
}

interface FetchingAuthStatusAction {
  type: typeof LOGIN_REQUEST;
}

interface AuthFailureAction {
  type: typeof AUTH_FAILURE;
}

interface LoginSuccessfulAction {
  type: typeof LOGIN_SUCCESSFUL;
  user: User;
  authenticatedWithKeycloak?: boolean;
}

interface LoginFailedAction {
  type: typeof LOGIN_FAILED;
  isFetching: boolean;
  isAuthenticated: boolean;
  message: string;
}

interface SetInitiatePasswordChangeAction {
  type: typeof INITIATE_PASSWORD_CHANGE;
}

interface SetUsernameAction {
  type: typeof SET_USERNAME;
  user: User;
}

interface SetAuthenticatedWithKeycloakAction {
  type: typeof SET_AUTHENTICATED_WITH_KEYCLOAK;
  authenticatedWithKeycloak: boolean;
}

interface LoggingOutAction {
  type: typeof LOGOUT_REQUEST;
}

interface LogoutSuccessfulAction {
  type: typeof LOGOUT_SUCCESSFUL;
}

interface LogoutFailedAction {
  type: typeof LOGOUT_FAILED;
  message: string;
}

interface ResetLockoutDurationAction {
  type: typeof RESET_LOCKOUT;
}

interface SetSessionMaxAgeAction {
  type: typeof SESSION_MAX_AGE;
  sessionTotalLength: number;
}

interface SetSessionExpiryAction {
  type: typeof SET_SESSION_EXPIRY;
  sessionExpiry: string;
}

export type AuthenticationActionType =
  | SetFailureMessageAction
  | StartSpinnerAction
  | StopSpinnerAction
  | SetTokensAction
  | FetchingAuthStatusAction
  | AuthFailureAction
  | LoginSuccessfulAction
  | LoginFailedAction
  | SetInitiatePasswordChangeAction
  | SetUsernameAction
  | SetAuthenticatedWithKeycloakAction
  | LoggingOutAction
  | LogoutSuccessfulAction
  | LogoutFailedAction
  | ResetLockoutDurationAction
  | SetSessionMaxAgeAction
  | SetSessionExpiryAction;
